module.exports = __webpack_public_path__ + "img/al_ghuair.129faea0.png";